module.exports = __webpack_public_path__ + "img/admins-active.414aca13.svg";